import {OrpyxRoleType} from "admins-dashboard/http-clients/index";

export class AdminAuditLoggingPolicies {
    static readonly Export = OrpyxRoleType.Audit;
}

export default AdminAuditLoggingPolicies;
